import type { ElementType, HTMLAttributes, ReactNode, Ref } from "react"

import { gapScale } from "@/components/ui/layout"
import { tv, type VariantProps } from "@/lib/utils/tv"

const grid = tv({
  base: "grid",
  variants: {
    cols: { 2: "grid-cols-2", 3: "grid-cols-3", 4: "grid-cols-4" },
    colsDesktop: {
      2: "@3xl:grid-cols-2",
      3: "@3xl:grid-cols-3",
      4: "@3xl:grid-cols-4",
      5: "@3xl:grid-cols-5",
      6: "@3xl:grid-cols-6",
      7: "@3xl:grid-cols-7",
      8: "@3xl:grid-cols-8",
    },
    gap: gapScale,
  },
  defaultVariants: { cols: 2, gap: "300" },
})

interface GridProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof grid> {
  ref?: Ref<HTMLElement>
  as?: ElementType
  children?: ReactNode
}

export const Grid = ({ cols, colsDesktop, gap, as, className, children, ...rest }: GridProps) => {
  const Element = as ?? "div"
  return (
    <Element className={grid({ cols, colsDesktop, gap, className })} {...rest}>
      {children}
    </Element>
  )
}
